<div class="ca-tabs">
  @for (route of routes; track route) {
    <a
      class="ca-tab"
      routerLinkActive="active"
      [routerLink]="[route.path]"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      {{ (translationPrefix() ?? "tab.") + route.path | transloco }}
    </a>
  }
</div>
